import Parser from 'html-react-parser';

const Preview = (props) => {
    const { content } = props;
    return (Parser(content || ''));
}

export default Preview;